// NotFound.tsx
import { ErrorWrapper } from '@/components/organisms/ErrorWrapper/ErrorWrapper'

export function NotFound (): JSX.Element {
  return (
    <ErrorWrapper title='error' errorCode='404' />
  )
}
